import axios from "../http_v2";

export default {
  list(params) {
    return axios.post("formbuilder/form/page", params);
  }
};
